<template>
<!-- 系统广播 -->
<div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box" style="height:100%">
        <el-table  :data="responseData.list" height="100%"  
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }">
            <el-table-column width="70" label="序号" align="center" type="index">
          </el-table-column>

            <el-table-column prop="voiceName"  label="广播名称" align="center">
            </el-table-column>

            <el-table-column prop="voiceType"  label="广播类型" width="100" align="center">
                <template slot-scope="rowData">
                    {{$store.state.select.broadcastType[rowData.row.voiceType].nameOne}}
                </template>
            </el-table-column>


            <el-table-column  label="操作" align="center" width="180">
                <template slot-scope="rowData">
                    <div class="button_div">
                

                        <el-tooltip class="item" effect="dark" content="播放" placement="top" v-if="!rowData.row.playStatus">
                            <el-button type="success" plain size="mini"  @click="selRadio(rowData.row)" icon="glyphicon glyphicon-play"></el-button>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="停止" placement="top" v-if="rowData.row.playStatus">
                            <el-button type="info" plain size="mini"  @click="selRadioStop(rowData.row.id)" icon="glyphicon glyphicon-stop"></el-button>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="试听" placement="top">
                            <el-button type="primary" plain size="mini"  @click="auditionBroadcast(rowData.row)" icon="glyphicon glyphicon-headphones"></el-button>
                        </el-tooltip>

                    </div>
                </template>
            </el-table-column>

        </el-table>
      </div>
        <el-dialog title="广播试听" :visible.sync="dialog.auditionDialog" width="30%" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" center>
            <div class="text-center">
                <audio :src="auditionBroadcastUrl" controls="controls">
                    您的浏览器不支持音乐播放器！
                </audio>
            </div>
            <div class="text-center">
                {{auditionBroadcastUrl}}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="glyphicon glyphicon-eye-close" @click="dialog.auditionDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import BroadcastResourceManagement from '@/components/BroadcastResourceManagement'
export default {
    name:'',
    components: {BroadcastResourceManagement},
    props: {},
    data() {
        return {
            dialog:{
               auditionDialog:false,
            },
            responseData:{
                list:[],
            },
            // 试听广播的音频资源
            auditionBroadcastUrl:'',
            broadcastBrand: "", // 0 智慧广播，1 云广播

            // 广播记录数据
            broadcastRecordData:{
                userName:this.$store.state.userInfo.name,
                voiceName:'',
                schoolId:this.$store.state.schoolId,
                userId:this.$store.state.userInfo.id,
            },
            selectRadio: {}, // 选中的广播
            tids: [], // 终端id数组
            catalogId: "", // 节目id
            vol: 56, // 音量 1-56
            sId: "", // 会话id
            status: 0 // 广播播放状态 0-stop 1- play 2- pause
        };
    },
    created() {
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.broadcastRecordData.userName = userInfo.userName;
        this.broadcastRecordData.userId = userInfo.userId;
        this.getDataList();
        this.getBroadcastBrand();
        this.getBroadcastAreaInfo();
        window.addEventListener("beforeunload", () => {
            if (this.status == 1) {
                this.selRadioStop();
            }
        });
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        // 获取校园广播品牌
        async getBroadcastBrand() {
            let req = {
                schoolId: this.$store.state.schoolId
            };
            let res = await this.$Http.getBroadcastBrand(req);
            if (res.code == 200) {
                this.broadcastBrand = res.data;
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        },
        // 播放广播
        async addBroadcastRecord(data){
            // console.log(data)
            let req = this.broadcastRecordData;
            let res = await this.$Http.addBroadcastRecord(req,true)
            if(res.code == 200){
                this.$message({
                    message: '广播已播放',
                    type: 'success'
                });
            }else if(res.code == 101){

            } else {
                this.$message({
                    message: '播放失败',
                    type: 'error'
                });
            }
           
        },

        // 云广播播放音乐
        async playBroadcastCloud(fileId) {
            // if (this.broadcastGorupList.length >= 1) {
            //     return false;
            // }
            let req = {
                tids: this.tids,
                fileId: fileId,
                resources: 0
            };

            let res = await this.$Http.playBroadcastCloud(req);
            if (res.code == 200) {
                this.sId = Number(res.data.ultaskcode);
                this.status = 1;
                this.changeRadioShow(this.status);
            } else if (res.code == 101) {
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        },

        // 试听广播
        auditionBroadcast(data){
            if(data.audioUrl){
                this.auditionBroadcastUrl = this.$store.state.config.fileUrl+data.audioUrl
                this.dialog.auditionDialog = true
                return false
            }
            this.$message({
                message: '暂无试听的MP3文件',
                type: 'error'
            });
        },
        // 获取数据列表
        async getDataList(){
         
			var newParamData = {
            }
        
            let res = await  this.$Http.getSystemBroadcast(newParamData)
            // console.log(res)
			if(res.code == 200){
				// this.responseData.list = res.data
                // console.log(res.data)
                let audioList = res.data;
                audioList.forEach((element, index) => {
                    audioList[index].playStatus = false;
                    // if(item.id == element.id){
                    //     audioList[index].playStatus = false;
                    // }
                });
				this.responseData.list = audioList;
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },
        // 选择播放的广播
        selRadio(item) {
            this.$confirm("确定播放广播吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                // console.log(item)
                this.selectRadio = item;
                this.broadcastRecordData.voiceName  = item.voiceName
                this.catalogId = item.catalogId;
                // console.log(this.catalogId);
                if (this.broadcastBrand == 0) {
                    this.createBroadcastSession();
                } else {
                    this.playBroadcastCloud(item.fileId);
                }
            })
            .catch(() => {});
        },

        // 播放广播
        playRadio(item) {
            this.status = 1;
            this.playControlBroadcast();
        },
        // 停止广播
        selRadioStop(item) {
            this.status = 0;
            if (this.broadcastBrand == 0) {
                this.playControlBroadcast();
            } else {
                this.changeRadioShow(this.status);
            }
        },
        changeRadioShow(num) {
            if (num == 0) {
                // console.log("停止播放");
                let audioList = this.responseData.list;
                audioList.forEach((element, index) => {
                audioList[index].playStatus = false;
                // if(item.id == element.id){
                //     audioList[index].playStatus = false;
                // }
                });
                this.responseData.list = audioList;
                this.delBroadcastSession();
            } else if (num == 1) {
                // console.log("开始播放");
                // if (this.broadcastBrand == 0) {
                    this.addBroadcastRecord();
                // }
                let audioList = this.responseData.list;
                audioList.forEach((element, index) => {
                audioList[index].playStatus = false;
                if (this.selectRadio.id == element.id) {
                    audioList[index].playStatus = true;
                }
                });
            } else {
            }
        },
        // 应急广播-获取分区信息
        async getBroadcastAreaInfo() {
            let req = {
                schoolId: this.$store.state.schoolId
            };
            let res = await this.$Http.getBroadcastAreaInfo(req);
            if (res.code == 200) {
                // console.log(res);
                if (res.data.length > 0) {
                    let tids = [];
                    res.data.forEach((element) => {
                        tids.push(Number(element.areaNum));
                    });
                    this.tids = tids;
                }
            } else if (res.code == 101) {
            } else {
                this.$message({
                    type: "error",
                    message: res.messsage
                });
            }
        },
        // 应急广播-创建会话
        async createBroadcastSession() {
            let req = {
                tids: this.tids,
                catalogId: this.catalogId,
                vol: this.vol
            };
            let res = await this.$Http.createBroadcastSession(req);
            if (res.code == 200) {
                // console.log(res);
                this.sId = Number(res.data);
                this.playBroadcast();
            } else if (res.code == 101) {
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        },
        // 应急广播-播放媒体库文件
        async playBroadcast() {
            let req = {
                sId: this.sId,
                catalogId: this.catalogId
            };
            let res = await this.$Http.playBroadcast(req);
            // console.log(res);
            if (res.code == 200) {
                this.time = Number(res.data);
                this.playRadio();
            } else if (res.code == 101) {
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        },
        // 应急广播-文件广播播放控制
        async playControlBroadcast() {
            let req = {
                sId: this.sId,
                status: this.status
            };
            let res = await this.$Http.playControlBroadcast(req);
            // console.log(res);
            if (res.code == 200) {
                this.changeRadioShow(this.status);
            } else if (res.code == 101) {
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        },
        // 应急广播-删除文件广播会话
        async delBroadcastSession() {
            let req = {
                sId: this.sId
            };
            let res = await this.$Http.delBroadcastSession(req);
            // console.log(res);
            if (res.code == 200) {
                this.$message({
                    message: '广播已停止',
                    type: 'success'
                });
            } else if (res.code == 101) {
            } else {
                this.$message({
                type: "error",
                message: res.messsage
                });
            }
        }
    }
};
</script>
<style scoped>
</style>